'use strict';

var FaresOptimizerAnalysisConfig = function FaresOptimizerAnalysisConfig($stateProvider) {
  $stateProvider.state('app.fares-optimizer-analysis', {
    url: '/workflow/fares-optimizer-analysis',
    ifFeatureEnabled: ['FARES_OPTIMIZER'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<rm-fares-optimizer-analysis></rm-fares-optimizer-analysis>'
      }
    }
  });
};
module.exports = FaresOptimizerAnalysisConfig;
FaresOptimizerAnalysisConfig.$inject = ['$stateProvider'];